<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 15.866 15.866"
  >
    <path
      class="svg-primary"
      d="M7.933,0A7.933,7.933,0,1,1,0,7.933,7.928,7.928,0,0,1,7.933,0Zm0,.91a7.023,7.023,0,1,0,7.023,7.023A7.051,7.051,0,0,0,7.933.91Z"
    />
    <path
      class="svg-primary"
      d="M143.536,95a.5.5,0,0,1-.619.255.449.449,0,0,1-.218-.619A2.952,2.952,0,0,1,145.428,93a2.842,2.842,0,0,1,2.984,2.656,2.785,2.785,0,0,1-2.365,2.584v1.237a.482.482,0,0,1-.473.473.451.451,0,0,1-.437-.473V97.84a.43.43,0,0,1,.437-.473,1.873,1.873,0,0,0,1.892-1.71,1.911,1.911,0,0,0-2.038-1.747A2.1,2.1,0,0,0,143.536,95Z"
      transform="translate(-137.459 -89.616)"
    />
    <path
      class="svg-primary"
      d="M208.546,300a.575.575,0,0,1,.582.582.568.568,0,0,1-.582.546.56.56,0,0,1-.546-.546A.568.568,0,0,1,208.546,300Z"
      transform="translate(-200.431 -289.083)"
    />
  </svg>
</template>
<script>
export default {};
</script>
